var map = {
	"./bingbao.png": "21c2",
	"./lei.png": "f91d",
	"./qing.png": "78b7",
	"./shachen.png": "39d8",
	"./wu.png": "1fd5",
	"./xue.png": "e17e",
	"./yin.png": "74e4",
	"./yu.png": "33d3",
	"./yun.png": "d84b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9c4f";